export function coalesceStringAllowEmpty(...values: unknown[]): string | null {
	for (const value of values) {
		if (typeof value === 'string') {
			return value;
		}
	}
	return null;
}
